var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: 1,
    height: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.047 13H3a1 1 0 01-.117-1.993L3 11h5.045c.235-3.188 1.338-6.213 3.16-8.606a1 1 0 011.59 0c1.817 2.387 2.92 5.401 3.158 8.606H21a1 1 0 01.117 1.993L21 13h-5.045c-.235 3.188-1.338 6.213-3.16 8.606a1 1 0 01-1.59 0C9.387 19.219 8.284 16.205 8.046 13zm2.004 0c.185 2.217.843 4.332 1.903 6.138l.046.075.046-.075c1.064-1.811 1.723-3.932 1.905-6.138h-3.9zm3.898-2c-.185-2.217-.843-4.332-1.903-6.138L12 4.786l-.046.076C10.89 6.673 10.231 8.794 10.05 11h3.9z",
    clipRule: "evenodd",
    fillOpacity: 0.75,
    fill: "#EFF1F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z",
    clipRule: "evenodd",
    fillOpacity: 0.75,
    fill: "#EFF1F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.1d33ededaa846252ea259801a923357b.svg";
export { ForwardRef as ReactComponent };